/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./PreFetchAPI',
	'../../../lib/@waca/core-client/js/core-client/utils/PerfUtils'
], (APIFactory, PreFetchAPI, PerfUtils) => {

	class PreFetch {

		constructor(){
			this.api = APIFactory.createAPI(this, [PreFetchAPI]);
		}

		static entries = []

		static get(id) {
			return window.__prefetch__ && window.__prefetch__[id];
		}

		static clear(id) {
			if(window.__prefetch__ && window.__prefetch__[id]){
				delete  window.__prefetch__[id];
			}
		}

		getAPI() {
			return this.api;
		}

		/**
		 * Get the pre-fetched response
		 * @param {string} id - the ID of the pre-fetched response
		 * @return {Promise} Resolved with the pre-fetched response
		 */
		get(id) {
			return PreFetch.get(id);
		}

		/**
		 * Deletes the pre-fetched entry
		 * @param {string} id - the ID of the pre-fetched response
		 */
		clear(id) {
			return PreFetch.clear(id);
		}

		static addEntry(entry){
			return PreFetch.entries.push(entry);
		}

		static load(perspectiveModel, glassInitPromise){

			const isCA = perspectiveModel && perspectiveModel.content
			&& perspectiveModel.content.options && perspectiveModel.content.options.config
			&& perspectiveModel.content.options.config.product === 'CA';

			if(isCA){
				PerfUtils.createPerformanceMark({
					'component': 'dashboard',
					'name': 'WarmUp.warm',
					'state': 'start'
				});
				const collection = perspectiveModel.collectionContainers.find(collection => collection.id === 'com.ibm.bi.dashboard.preFetch') || {};
				(collection.items || []).forEach(item => PreFetch.addEntry(item));
				glassInitPromise
					.then(glassContext => {
						const ajaxSvc = glassContext.getCoreSvc('.Ajax');
						const promises = [];
						window.__prefetch__ = {};
						PreFetch.entries.forEach(entry => {
							const params = entry.requestParams ? PreFetch._quickPick(entry, entry.requestParams) : entry;
							window.__prefetch__[entry.url] = ajaxSvc.ajax(params);
							if(entry.responseField){
								window.__prefetch__[entry.url] = window.__prefetch__[entry.url].then(response => response[entry.responseField]);
							}
							promises.push(window.__prefetch__[entry.url]);
						});
						return Promise.all(promises);
					})
					.finally(() => {
						PerfUtils.createPerformanceMark({
							'component': 'dashboard',
							'name': 'WarmUp.warm',
							'state': 'end'
						});
					});
			}


		}

		static _quickPick(object, keys = []){
			const clone = { ...object };
			Object.keys(clone).forEach(key => keys.indexOf(key) === -1 ? delete clone[key]: null);
			return clone;
		}

	}

	return PreFetch;
});
